import { createStore, type Store } from 'vuex';

import ui from './UI';

import ProductsStore from '@/modules/Products/store';
import AccountsStore from '@/modules/Accounts/store';
import PropertiesStore from '@/modules/Properties/store';
import ClustersStore from '@/modules/Clusters/store';
import SettingsStore from '@/modules/Settings/store';
import PreferencesStore from '@/modules/Preferences/store';
import NotificationsStore from '@/modules/Notifications/store';

const projectStore = {
  state() {
    return {};
  },
  mutations: {},
  actions: {},
  modules: {
    accounts: AccountsStore,
    properties: PropertiesStore,
    products: ProductsStore,
    clusters: ClustersStore,
    settings: SettingsStore,
    preferences: PreferencesStore,
    notifications: NotificationsStore,
    ui,
  },
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- legacy Vuex store typing
export const store: Store<any> = createStore(projectStore as any);
